import React, { FC } from "react";
import { IColor } from "../../utils/types/colors";
import { CalendarColorCircle } from "./CalendarColorCircle";
import '../../styles/components/calendarColorSelect.scss';

interface CalendarColorSelectProps {
  colors: IColor[];
  selectedColor: string;
  onChangeColor: (color: string) => void;
}

export const CalendarColorSelect: FC<CalendarColorSelectProps> = ({ colors, selectedColor, onChangeColor }) => {
  return (
    <div className="color-choose">
      {colors.map((color) => (
        <CalendarColorCircle 
          color={color} 
          selectedColorName={selectedColor} 
          onChangeColor={onChangeColor} 
        />
      ))}
    </div>
  )
}